// src/components/Navbar.js
import React, { useState } from 'react';
import './navbar.css';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { useSidebar } from '../contexts/SidebarContext';
import DateTimeDisplay from './DateTimeDisplay';
import mascot from '../Assets/logo_web.png';
import menuIcon from '../Assets/red-dots.svg';

function Navbar({ pageTitle }) {
  const [searchParams] = useSearchParams();
  const app = searchParams.get('app');
  const sidebar = useSidebar();
  const [showNavBar, setShowNavBar] = useState(app === 'besa' ? false : true);

  return (
    <div className="row navbar-row">
      <nav className="navbar" style={showNavBar ? undefined : { display: 'none' }}>
        <div className="navbar-left">
          {sidebar && (
            <button
              type="button"
              className="navbar-hamburger"
              onClick={sidebar.toggleSidebar}
              aria-label="Open menu"
            >
              <img src={menuIcon} alt="" className="navbar-menu-icon" aria-hidden="true" />
            </button>
          )}
          <div className="navbar-title-wrap">
            <Link to="/">
              <h1 className="pageTitle">{pageTitle}</h1>
            </Link>
          </div>
        </div>

        <div className="logo">
          <Link to="/">
            <img src={mascot} alt="Table Mate" />
          </Link>
        </div>

        <div className="date-time">
          <DateTimeDisplay />
        </div>
      </nav>
    </div>
  );
}

export default Navbar;

